import React, { Component } from 'react'
import { Navbar, Nav, NavDropdown, Row, Col, Image } from 'react-bootstrap'
import DRYCOM from '../Encabezado/DRYCOM.jpg'

export class Header extends Component {
    render() {
        return (
            /* Añadimos un estilo para que el Header siempre esté en su propia capa visual */
            <div style={{ position: 'relative', zIndex: 10, background: 'white' }}>
                
                {/* Definimos una altura mínima y alineación fija para el logo */}
                <Row className="align-items-center" style={{ minHeight: '150px', margin: 0 }}>
                    <Col></Col>
                    <Col xs={8} md={6} className="d-flex justify-content-center">
                        <Image src={DRYCOM} width="65%" style={{ maxWidth: '400px' }} />
                    </Col>
                    <Col></Col>
                </Row>

                <Navbar collapseOnSelect bg="primary" expand="lg" variant="dark" className="shadow-sm">
                    <Navbar.Toggle aria-controls="responsive-navbar-nav" className="ms-3" />
                    <Navbar.Collapse id="responsive-navbar-nav">
                        <Nav className="ms-3">
                            <Nav.Link href="/en/Home">Home</Nav.Link>
                            <Nav.Link href="/en/ColdChain">Cold chain</Nav.Link>
                            <Nav.Link href="/en/Instrumental">Instrumental</Nav.Link>
                            <Nav.Link href="/en/MedicalInput">Medical Supplies</Nav.Link>
                            
                            <NavDropdown title="Medicine" id="medicine-dropdown">
                                <NavDropdown.Item href="/en/MedCommercial">Brand Name Medications</NavDropdown.Item>
                                <NavDropdown.Divider />
                                <NavDropdown.Item href="/en/MedGeneric">Generic Medications</NavDropdown.Item>
                            </NavDropdown>

                            <NavDropdown title="Furniture and equipment" id="furniture-dropdown">
                                <NavDropdown.Item href="/en/FeClinical">Clinical</NavDropdown.Item>
                                <NavDropdown.Divider />
                                <NavDropdown.Item href="/en/FeDiagnosis">Diagnosis</NavDropdown.Item>
                                <NavDropdown.Divider />
                                <NavDropdown.Item href="/en/Emergency">Emergency</NavDropdown.Item>
                                <NavDropdown.Divider />
                                <NavDropdown.Item href="/en/Bedridden">Bedridden Care</NavDropdown.Item>
                                <NavDropdown.Divider />
                                <NavDropdown.Item href="/en/Gynecology">Gynecology</NavDropdown.Item>
                                <NavDropdown.Divider />
                                <NavDropdown.Item href="/en/Intensive">Intensive Care</NavDropdown.Item>
                                <NavDropdown.Divider />
                                <NavDropdown.Item href="/en/MedEducational">Medical & Educational</NavDropdown.Item>
                                <NavDropdown.Divider />
                                <NavDropdown.Item href="/en/Neonatology">Neonatology</NavDropdown.Item>
                                <NavDropdown.Divider />
                                <NavDropdown.Item href="/en/Weight">Weight and Height</NavDropdown.Item>
                                <NavDropdown.Divider />
                                <NavDropdown.Item href="/en/Rehabilitation">Rehabilitation</NavDropdown.Item>
                                <NavDropdown.Divider />
                                <NavDropdown.Item href="/en/Operations">Operating Room</NavDropdown.Item>
                                <NavDropdown.Divider />
                                <NavDropdown.Item href="/en/FirstAids">First Aid</NavDropdown.Item>
                            </NavDropdown>
                            
                            <Nav.Link href="/en/ContactUs">Contact Us</Nav.Link>
                        </Nav>
                    </Navbar.Collapse>

                    <Navbar.Collapse className="justify-content-end me-3">
                        <Navbar.Text className="text-white">
                            Ir al sitio en <a href="/" className="text-white fw-bold">Español</a>
                        </Navbar.Text>
                    </Navbar.Collapse>
                </Navbar>
            </div>
        )
    }
}